import React, { useEffect, useState } from 'react';
import Header from './Header';
import { Link, useParams } from 'react-router-dom';

const Coursepage = () => {
  const { category } = useParams();
  const [courses, setCourses] = useState([]);

  // Decode category from URL
  const normalizedCategory = decodeURIComponent(category || "");

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/course/coursedetails`);
        const data = await response.json();

        // Filter courses by category (case-insensitive)
        const filteredCourses = data.filter(
          (item) => item.category_name.toLowerCase() === normalizedCategory.toLowerCase()
        );

        setCourses(filteredCourses);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, [normalizedCategory]);
  const uniqueCourses = [...new Set(courses.map(course => course.course_name))].map(name => {
    return courses.find(course => course.course_name === name);
  });

  return (
    <div>
      <Header />
      <h2 style={{ textAlign: 'center', color: '#2873b9ff', margin: '20px 0' }}>
        {normalizedCategory}
      </h2>

      {courses.length === 0 && <p style={{ textAlign: 'center' }}>No courses found.</p>}

      <ul style={{ maxWidth: '800px', margin: '0 auto', padding: 0 }}>
        {uniqueCourses.map((item, index) => (
          <Link
            key={index}
            to={`/${encodeURIComponent(normalizedCategory)}/${encodeURIComponent(item.course_name)}`}
            style={{ textDecoration: 'none' }}
          >
            <li style={{
              listStyleType: 'none',
              margin: '8px 0',
              border: '1px solid #2873b9ff',
              padding: '20px',
              borderRadius: '8px',
              backgroundColor: '#f9f9ff',
              color: 'black',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              {item.course_name}
              <span>{item.price} RS</span>
            </li>
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default Coursepage;
